import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Layout::Section>\n  <Page::Dashboard\n    @dateOption={{this.dateOption}}\n    @updateDateOption={{this.updateDateOption}}\n  />\n</Layout::Section>")